
export const wxLinks = {
  winds: "https://aviationweather.gov/data/windtemp/?region=mia&fcst=12&level=low",
  metar: "https://aviationweather.gov/data/metar",
  taf: "https://aviationweather.gov/data/taf",

};